import { LOG_LEVEL, LOG_GROUPS, isProduction2, DEBUG } from './config';
import debug from './thirdParties/debug';
import logGroups from './logGroups';

export const logExchange = debug(logGroups.exchange);
export const logInbox = debug(logGroups.inbox);
export const logThreads = debug(logGroups.threads);
export const logNotifications = debug(logGroups.notifications);
export const logReviews = debug(logGroups.reviews);
export const logSQL = debug(logGroups.sql);
export const logEditProfile = debug(logGroups.editProfile);
export const logInit = debug(logGroups.init);
export const logGraphQL = debug(logGroups.graphQL);
export const logUser = debug(logGroups.user);
export const logReservation = debug(logGroups.reservation);
export const logHook = debug(logGroups.hooks);
export const logHookWithValue = str => val => {
  logHook(str, val);
  return val;
};

logInit('LOG_LEVEL', LOG_LEVEL);
logInit('DEBUG', DEBUG);
logInit('ENV ' + process.env.ENV + ' NODE_ENV ' + process.env.NODE_ENV);

const pino = require('pino');

const logger = pino({
  level: LOG_LEVEL || 'trace',
  prettyPrint: {
    levelFirst: true,
    colorize: true,
  },
  prettifier: require('pino-pretty'),
});

logger.trace = logger.trace.bind(logger);

export function trace(group = '', prefix = '') {
  if (LOG_LEVEL !== 'trace') {
    return () => {};
  }

  const prependPrefixToTrace = message => {
    const formatPrefix = prefix + (prefix ? ': ' : '');
    logger.trace(formatPrefix, message);
  };

  if (isProduction2) {
    if (!LOG_GROUPS || LOG_GROUPS.length < 1 || LOG_GROUPS.indexOf(group) < 0) {
      return () => {};
    }
    return prependPrefixToTrace;
  }
  return prependPrefixToTrace;
}

export default logger;

export const colors = {
  Reset: '\x1b[0m',
  Bright: '\x1b[1m',
  Dim: '\x1b[2m',
  Underscore: '\x1b[4m',
  Blink: '\x1b[5m',
  Reverse: '\x1b[7m',
  Hidden: '\x1b[8m',
  FgBlack: '\x1b[30m',
  FgRed: '\x1b[31m',
  FgGreen: '\x1b[32m',
  FgYellow: '\x1b[33m',
  FgBlue: '\x1b[34m',
  FgMagenta: '\x1b[35m',
  FgCyan: '\x1b[36m',
  FgWhite: '\x1b[37m',
  BgBlack: '\x1b[40m',
  BgRed: '\x1b[41m',
  BgGreen: '\x1b[42m',
  BgYellow: '\x1b[43m',
  BgBlue: '\x1b[44m',
  BgMagenta: '\x1b[45m',
  BgCyan: '\x1b[46m',
  BgWhite: '\x1b[47m',
};



// WEBPACK FOOTER //
// ./src/logger.js